export const SET_SB_USER = 'SET_SB_USER'
export const RESET_SB_USER = 'RESET_SB_USER'
export const SET_MESSAGE_LIST = 'SET_MESSAGE_LIST'
export const SET_MESSAGE_LOADING = 'SET_MESSAGE_LOADING'
export const RESET_MESSAGE = 'RESET_MESSAGE'
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const SET_LOADING_CHANNEL = 'SET_LOADING_CHANNEL'
export const SET_CHANNEL_LIST = 'SET_CHANNEL_LIST'
export const SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL'
